// w16 Sentabr — variant. Same iframe pattern as Bookie / Avgust.
// The HTML at /templates/sentabr.html owns the dark-midnight design
// and a per-template customizer that swaps Nigora/Sherzod/28.09.2026/
// To'yxona/Toshkent shahri for the user's saved values.

import type { VariantProps } from "./types";
import { getLocale } from "@/lib/i18n";

const TEMPLATE_HTML = "/templates/sentabr.html";

export function SentabrStaticVariant({ t, ctx }: VariantProps) {
  const params = new URLSearchParams();
  if (t.names) params.set("names", t.names);
  if (t.date) params.set("date", t.date);
  if (t.venue) params.set("venue", t.venue);
  if (t.address) params.set("address", t.address);
  if (t.time) params.set("time", t.time);
  // Real published invitations: forward the public slug so the iframe's
  // RSVP form can POST to /api/v1/public/i/<slug>/rsvp. Demo / preview
  // mode leaves it unset and the iframe just shows the thank-you state.
  if (ctx.slug) params.set("slug", ctx.slug);
  params.set("v", "3");

  // Demo/catalog preview (no real invitation slug): default the template's
  // in-iframe language to the app locale, so taklifla.com previews render in
  // English (and a RU viewer sees Russian). The HTMLs read ?lang= (all) and
  // ?default_lang= (newer premium ones) — set both. Owner-published
  // invitations (ctx.slug set) keep their own default_lang / built-in default.
  if (!ctx.slug) {
    const _loc = getLocale();
    if (!params.has("lang")) params.set("lang", _loc);
    if (!params.has("default_lang")) params.set("default_lang", _loc);
  }
  const src = `${TEMPLATE_HTML}?${params.toString()}`;
  return (
    <iframe
      src={src}
      title={t.names || "Sentabr"}
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100svh",
        border: "none",
        display: "block",
        background: "#14202F",
      }}
    />
  );
}
